
import styles from './Subtitle.module.scss';
import cn from 'classnames';
export const Subtitle = ({ children, className, ...props }) => {
  return (
    <p className={cn(styles.subtitle, className)} {...props}>{children}</p>
  )
}